import { render, staticRenderFns } from "./InputSigarusEditor.vue?vue&type=template&id=1f56b051"
import script from "./InputSigarusEditor.vue?vue&type=script&lang=js"
export * from "./InputSigarusEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports